import * as requestLeaseStatuses from 'constants/enums/requestLeaseStatuses'

export default {
  [requestLeaseStatuses.NEW]: 'Nová',
  [requestLeaseStatuses.COMPLETION]: 'K dokončení',
  [requestLeaseStatuses.GENERATION]: 'Generování',
  [requestLeaseStatuses.PROCESSING]: 'Ve zpracování',
  [requestLeaseStatuses.CLOSED]: 'Uzavřená',
  [requestLeaseStatuses.CANCELLED]: 'Zrušená',
} as const
